<!-- Modal: Add Tags (mismo tamaño/posición que Change Status / Group Name) -->
<div class="bulk-modal-overlay bulk-modal-overlay--legacy-sized" *ngIf="activeModal === 'modal-tag'" (click)="closeModal()">
  <div class="bulk-modal-content bulk-modal-tags bulk-modal-shell-legacy" (click)="$event.stopPropagation()">
    <div class="bulk-asset-modal-layout">
      <div class="bulk-asset-modal-body">
        <h4>Add Additional Tags</h4>
        <clearanceItem-tag #tagComponent [isClearanceUser]="isClearanceUser" [projectId]="projectId"
          (newTagAdded)="newTagAdded($event)" [canTagsBeToggled]="tagsCanBeEdited"></clearanceItem-tag>
      </div>
      <div class="bulk-asset-modal-footer">
        <button mat-button class="btn-flat" (click)="addTags()">Accept</button>
        <button mat-button class="btn-flat" (click)="closeModal()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal: Add Releases (mismo tamaño legacy: top ~10%, alto ~70vh) -->
<div class="bulk-modal-overlay bulk-modal-overlay--legacy-sized" *ngIf="activeModal === 'modal-release'" (click)="closeModal()">
  <div class="bulk-modal-content bulk-modal-releases bulk-modal-shell-legacy bulk-modal-shell-legacy--asset" (click)="$event.stopPropagation()">
    <div class="bulk-asset-modal-layout">
      <div class="bulk-asset-modal-body">
        <h4>Add Additional Releases</h4>
        <clearance-asset-manager #documentAsset assetType="document" asset="Document-Bulk" [images]="dataList"
          [projectId]="projectId" [ownerType]="'ci'"></clearance-asset-manager>
      </div>
      <div class="bulk-asset-modal-footer">
        <button mat-button class="btn-flat" (click)="addDocuments()">Add</button>
        <button mat-button class="btn-flat" (click)="closeModal()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal: Add Images (mismo tamaño legacy: top ~10%, alto ~70vh) -->
<div class="bulk-modal-overlay bulk-modal-overlay--legacy-sized" *ngIf="activeModal === 'modal-image'" (click)="closeModal()">
  <div class="bulk-modal-content bulk-modal-images bulk-modal-shell-legacy bulk-modal-shell-legacy--asset" (click)="$event.stopPropagation()">
    <div class="bulk-asset-modal-layout">
      <div class="bulk-asset-modal-body">
        <h4>Add Additional Images</h4>
        <clearance-asset-manager #imageAsset assetType="image" asset="Image-Bulk" [projectId]="projectId"
          [images]="dataList" [hideReportDefaultIcons]="true" [ownerType]="'ci'" [showOpenInNew]="true"></clearance-asset-manager>
      </div>
      <div class="bulk-asset-modal-footer">
        <button mat-button class="btn-flat" (click)="addImages()">Add</button>
        <button mat-button class="btn-flat" (click)="closeModal()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal: Change Status (mismo tamaño/posición que Group Name: top ~10%, alto ~70vh) -->
<div class="bulk-modal-overlay bulk-modal-overlay--legacy-sized" *ngIf="activeModal === 'modal-status'" (click)="closeModal()">
  <div class="bulk-modal-content bulk-modal-status bulk-modal-shell-legacy" (click)="$event.stopPropagation()">
    <form novalidate [formGroup]="bulkForm" class="bulk-status-modal-form">
      <div class="bulk-status-modal-body">
        <h4>Change Status</h4>
        <mat-form-field appearance="fill" style="width: 100%">
          <mat-label>Status</mat-label>
          <mat-select formControlName="status">
            <mat-option *ngFor="let stat of dataList" [value]="stat.name">{{ stat.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%" *ngIf="showComments">
          <mat-label>Comments</mat-label>
          <textarea matInput formControlName="comments" maxlength="255"></textarea>
        </mat-form-field>
      </div>
      <div class="bulk-status-modal-footer">
        <button mat-button class="btn-flat" (click)="changeStatus()" type="submit">Change</button>
        <button mat-button class="btn-flat" (click)="closeModal()" type="button">Cancel</button>
      </div>
    </form>
  </div>
</div>

<!-- Modal: Group Name (posición y proporciones alineadas con modal Materialize legacy: ~10% desde arriba, alto ~70%) -->
<div class="bulk-modal-overlay bulk-modal-overlay--legacy-sized" *ngIf="activeModal === 'modal-groupName'" (click)="closeModal()">
  <div class="bulk-modal-content bulk-modal-groupname bulk-modal-shell-legacy" (click)="$event.stopPropagation()">
    <group-name #groupName [projectId]="projectId" [itemList]="itemList"
      (groupNameUpdated)="onGroupNameUpdate($event)" (cancelled)="closeModal()"></group-name>
  </div>
</div>
